class DialogUtil {
  /**
   * Displays browser alert according to the device/browser styling.
   * @param {String} message - The text to put in the dialog's body.
   */
  static errorAlert (message) {
    window.alert(message)
  }
}

export default DialogUtil
